import { Button, PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';
import ContactIcons from "./ContactIcons"
import './Contact.css';

function Contact() {
  return (
    <div className='Contact'>
      <Button id='ContactButton' color="primary" className='contact-button'>📨</ Button>
      <UncontrolledPopover placement='left' target="ContactButton" trigger="click">
        <PopoverHeader>Contact Info</PopoverHeader>
        <PopoverBody>
          <ContactIcons />
        </PopoverBody>
      </UncontrolledPopover>
    </div>
  );
}

export default Contact;